import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let promise = null;

const EMPTY = { images: {}, latestDrop: [], collections: [] };

export function loadSiteContent(force = false) {
    if (!promise || force) {
        promise = fetch(`${API}/site-content`)
            .then((r) => (r.ok ? r.json() : EMPTY))
            .then((d) => {
                cache = { images: d.images || {}, latestDrop: d.latest_drop || [], collections: d.collections || [] };
                return cache;
            })
            .catch(() => cache || EMPTY);
    }
    return promise;
}

export function useSiteContent() {
    const [data, setData] = useState(cache || EMPTY);
    useEffect(() => {
        loadSiteContent().then(setData);
    }, []);
    return data;
}

export function useSiteImages() {
    return useSiteContent().images;
}
